import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ObterTokenCdhu } from './types';

export const INITIAL_STATE: ObterTokenCdhu = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ObterTokenCdhu {
	return produce(state, draft => {
		switch (action.type) {
			case Types.OBTER_TOKEN_CDHU_REQUEST: {
				break;
			}
			case Types.OBTER_TOKEN_CDHU_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.OBTER_TOKEN_CDHU_FAILURE: {
				draft.status = 400;
				draft.data = null;
				break;
			}
				case Types.OBTER_TOKEN_CDHU_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}

		return draft;
	});
}
